<!-- Copyright © 2023 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and -->
<!-- matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, -->
<!-- including without limitation, material generated from the software programs which are displayed on the screen such -->
<!-- as icons, screen display looks, etc. -->
<section class="select-country">
  <div class="action-bar clear">
    <div class="left">
      <button
        type="button"
        class="xrx-btn btn-secondary btn medium glyph xgl-close mfd"
        data-dismiss="modal"
        aria-label="Close"
        (click)="activeModal.dismiss()">
        <span aria-hidden="true" class="xgl-close"></span>
      </button>
    </div>
    <div class="right">
      <button
        class="xrx-btn btn-secondary btn medium glyph xgl-navigate_right"
        type="button"
        (click)="activeModal.close(selectedValue)">
        <span class="btn-label text-medium button-forward-label" xdaTranslate
          >SDE_OK</span
        >
      </button>
    </div>
    <div class="middle">
      <span class="title text-x-large">{{ title }}</span>
    </div>
  </div>

  <div class="modal-body scroll-content" iscroll tabindex="-1">
    <div>
      <ul>
        @for (country of countryList; track country) {
          <li>
            <button
              type="button"
              class="xrx-btn btn-secondary btn medium w-100"
              [ngClass]="{
                selected:
                  selectedValue.key === country.key &&
                  selectedValue.value === country.value,
              }"
              (click)="setValue(country)">
              <span>{{ country.value }}</span>
            </button>
          </li>
        }
      </ul>
    </div>
  </div>
</section>
